// NOTE: type guard fix for optional chaining - https://github.com/microsoft/TypeScript/pull/55613
export function isBoolean(val) {
    return typeof val === 'boolean';
}
export function isOneOf(val, values) {
    return values.includes(val);
}
export function isSet(val) {
    return val instanceof Set;
}
